import { Component } from 'react';
import { getAllItems } from '../../services/JsonFetchService.js';
import './Information.css';

class Information extends Component {
    constructor() {
        super();
        this.state = { infoItems: [] };
    }

    async componentDidMount() {
        const infoItems = await getAllItems('/information/information.json');
        if (infoItems.length > 0) {
            this.setState({ infoItems: infoItems })
        }
    }

    render() {
        return (
            <div>
                <h2 className='information__title'>Информация</h2>
                <div className="container">
                    {this.state.infoItems.map((item, index) => (
                        <div className="row mb-5" key={index}>
                            <h5 className="information-item__title">{item.title}</h5>
                            <iframe src={item.content} height="442" width="786" title={"Information_"+index}></iframe>
                        </div>
                    ))}
                </div>
            </div>
        )
    }
}

export default Information;